import React, { useEffect } from 'react'
import Brightness5Icon from '@mui/icons-material/Brightness5'
import LightModeIcon from '@mui/icons-material/LightMode'
import ModeNightIcon from '@mui/icons-material/ModeNight'
import WbCloudyIcon from '@mui/icons-material/WbCloudy'
import SquareFootIcon from '@mui/icons-material/SquareFoot'
import { ButtonGroup } from '@mui/material'
import { useVerandaDispatch, useVerandaSelector } from '..'
import {
  setAlignmentMode,
  setNightMode,
  setShadingMode,
} from '../store/scene/sceneSlice'
import { SceneButtonExtended } from './scene/SceneButtonExtended'
import { EditDynamicSettings, useDynamicTranslation } from '@k3/core'

const VerandaSceneButtons = (props: any): JSX.Element | null => {
  const dispatch = useVerandaDispatch()
  const nightModeAllowed = useVerandaSelector(
    (state) => state.configuratorRights.nightMode
  )
  const nightMode = useVerandaSelector((state) => state.scene.nightMode)
  const shadingMode = useVerandaSelector((state) => state.scene.shadingMode)
  const alignment = useVerandaSelector((state) => state.scene.alignment)

  const getTranslation = useDynamicTranslation()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    if (nightModeAllowed) {
      dispatch(setNightMode(params.get('view') === 'night' ? true : false))
    }
    dispatch(setShadingMode(params.get('mode') === 'shading' ? true : false))
  }, [dispatch, nightModeAllowed])

  //selectiere alle scenebuttons ids und setze mit css hover texte
  useEffect(() => {
    const sceneButtons = document.querySelectorAll('.MuiToggleButton-root')

    sceneButtons.forEach((button) => {
      const id = button.id
      const hoverText = button.getAttribute('aria-label')
      if (hoverText) {
        button.setAttribute('title', hoverText)
      }
    })
  }, [])
  const Wrapped = props.Wrapped

  return (
    <>
      <Wrapped />

      <ButtonGroup
        variant="text"
        color="primary"
        aria-label=""
        style={{
          zIndex: 2,
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          pointerEvents: 'all',
        }}
      >
        <SceneButtonExtended
          value={alignment}
          defaultValue={true}
          label={getTranslation('masslinienLabel')}
          id={'masslinien'}
          onChange={() => dispatch(setAlignmentMode(!alignment))}
        >
          <EditDynamicSettings keys={['masslinienLabel']} display="dialog" />
          <SquareFootIcon />
        </SceneButtonExtended>

        <SceneButtonExtended
          value={shadingMode}
          defaultValue={true}
          label={getTranslation('shadingLabel')}
          id={'shading'}
          onChange={() => dispatch(setShadingMode(!shadingMode))}
        >
          <EditDynamicSettings keys={['shadingLabel']} display="dialog" />
          {shadingMode ? <Brightness5Icon /> : <WbCloudyIcon />}
        </SceneButtonExtended>
        {nightModeAllowed && (
          <SceneButtonExtended
            value={nightMode}
            defaultValue={nightMode}
            label={getTranslation('nightLabel')}
            id={'night'}
            onChange={() => dispatch(setNightMode(!nightMode))}
          >
            <EditDynamicSettings keys={['nightLabel']} display="dialog" />
            {nightMode ? (
              <LightModeIcon
                sx={{
                  color: `yellow`,
                }}
              />
            ) : (
              <ModeNightIcon
                sx={{
                  color: `black`,
                }}
              />
            )}
          </SceneButtonExtended>
        )}
      </ButtonGroup>
    </>
  )
}

export default VerandaSceneButtons
